import { PromotionsGetterTypes } from './types';

export const getters = {
    [PromotionsGetterTypes.GetPromotions](state) {
        return (state.promotions && state.promotions.data) || [];
    },
    [PromotionsGetterTypes.GetResponse](state) {
        return state.promotions;
    },
    [PromotionsGetterTypes.GetPerPage](state) {
        return state.per_page;
    },
};
